import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {Link} from '@github-ui/react-router'
import {Link as PrimerLink} from '@primer/react'

export function ReferencedText({info}: {info: IssueEventInfo}) {
  const {commitAbbreviatedOid, commitRepositoryNameWithOwner, commitShortMessageText, commitUrl} = info
  const action = info.sessionUrl ? (
    <PrimerLink inline href={info.sessionUrl} className="fgColor-default text-semibold">
      referenced this
    </PrimerLink>
  ) : (
    'referenced this'
  )

  if (!commitAbbreviatedOid || !commitUrl) {
    return <>{action} pull request in a commit</>
  }

  return (
    <>
      {action}
      {commitRepositoryNameWithOwner ? (
        <>
          {' from '}
          <strong>{commitRepositoryNameWithOwner}</strong>
        </>
      ) : null}
      {' in '}
      <Link className="color-fg-muted text-underline" to={commitUrl}>
        <code>{commitShortMessageText || commitAbbreviatedOid}</code>
      </Link>
    </>
  )
}
